var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{staticStyle:{"background-color":"#f2f2f2"},attrs:{"view":"hhh lpr fff"}},[_c('HeaderComponent'),_c('q-page-container',[_c('Social'),_c('router-view')],1),_c('FooterComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }